import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithUserProductPackages = { userProductPackages: FilterState };

const userProductPackages = createSlice({
    name: 'userProductPackages',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userProductPackages.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userProductPackages.actions;
export const selectFilters = (state: StateWithUserProductPackages) => state.userProductPackages.filters;
